import React from 'react';
import { observer } from 'mobx-react-lite';
import Checkbox from '@JohnLewisPartnership/jl-design-system/dist/components/checkbox/Checkbox';
import styles from './WishListList.module.scss';
import cx from 'classnames';
import Cookies from 'js-cookie';
import { getExperiencesFromWindow, isFlagSet } from '../../helpers/featureFlags/featureFlags';
import { FEATURE_FLAGS } from '../../helpers/featureFlags/constants';
import { redirectToSignIn } from '../../helpers/redirect/redirect';
import { postMonetateImpressionByName } from '../../helpers/monetate/monetate';
import { GUEST_WISH_LIST_EXPERIENCE } from '../../stores/constants';
interface Props {
    handleWishListOnClick: (wishListId: string) => Promise<void>;
    wishLists?: ProductWishList[];
    isExpanded?: boolean;
    isSubmitting?: boolean;
    productId: string;
}

export const WishListList: React.FC<Props> = observer(
    ({ handleWishListOnClick, wishLists = [], isExpanded = false, isSubmitting = false, productId }: Props) => {
        // Can be reconsidered when thinking about animations
        if (!isExpanded || wishLists.length <= 1) {
            return null;
        }

        const mapWishListLabelName = (wishList: ProductWishList): string => {
            let labelName = wishList.name;
            if (wishList.isFull) {
                labelName += ' (Full)';
            }

            return labelName;
        };

        return (
            <div className={styles.listContainer} data-testid="wish-lists-list">
                {wishLists &&
                    wishLists.map((wishList) => {
                        return (
                            <Checkbox
                                data-testid={wishList.id}
                                id={wishList.id}
                                key={wishList.id}
                                name={wishList.id}
                                label={mapWishListLabelName(wishList)}
                                className={cx(styles.wishListItem, {
                                    [styles.isChecked]: wishList.isAdded,
                                })}
                                onClick={async (): Promise<void> => {
                                    const windowExperiences = getExperiencesFromWindow();
                                    const isGuest = !Cookies.get('shopperId');

                                    if (isGuest) {
                                        postMonetateImpressionByName(GUEST_WISH_LIST_EXPERIENCE, windowExperiences);
                                    }

                                    if (isGuest && !isFlagSet(FEATURE_FLAGS.GUEST_WISHLIST)) {
                                        // Guest user without guest wishlist feature flag
                                        redirectToSignIn(productId, 'button');
                                        return;
                                    } else {
                                        await handleWishListOnClick(wishList.id);
                                    }
                                }}
                                disabled={isSubmitting || wishList.isFull}
                                checked={wishList.isAdded}
                                isControlled={true}
                            />
                        );
                    })}
            </div>
        );
    },
);

export default WishListList;
